import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * FERTILITY HISTORY
   */
  {
    label:
      'We are so sorry that you are on this journey, but our mission is to support you every step of the way.',
    educationalSlide: `
    Please take a moment to fill out this welcome intake.
    Your answers will be kept confidential and only shared with your practitioner(s), and will play a key part in understanding how to best support.
    Thank you.
.`,
    field: 'gn_intake_0',
    type: 'info',
    answer: {}
  },
  {
    field: 'gn_intake_1',
    label: 'Have you been trying to become pregnant?',
    type: 'polar_check',
    answer: {
      label: 'For how long?',
      name: 'gn_intake_1_desc',
      type: 'text'
    }
  },
  {
    field: 'gn_intake_2',
    label: 'Have you ever seen fertility specialist(s) in the past?',
    type: 'polar_check',
    answer: {
      label: 'Name(s)?',
      name: 'gn_intake_2_desc',
      type: 'text'
    }
  },
  {
    field: 'gn_intake_3',
    label: 'Have you ever had fertility treatment in the past?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'gn_intake_3_A',
          value: 'Oral medication and timed intercourse'
        },
        { key: 'gn_intake_3_B', value: 'Oral medication and insemination' },
        {
          key: 'gn_intake_3_C',
          value: 'Daily injectable medication & insemination'
        },
        {
          key: 'gn_intake_3_D',
          value: 'In vitro fertilization (IVF):',
          answer: {
            type: 'list',
            items: [
              {
                label: '# of fresh cycles?',
                name: 'gn_intake_3_D1',
                type: 'number',
                placeholder: 'Please specify'
              },
              {
                label: '# of frozen cycles?',
                name: 'gn_intake_3_D2',
                type: 'number',
                placeholder: 'Please specify'
              }
            ]
          }
        },
        {
          key: 'gn_intake_3_E',
          value: 'Other',
          answer: {
            name: 'gn_intake_3_EE',
            type: 'text',
            placeholder: 'Please specify'
          }
        },
        { key: 'gn_intake_3_none', value: 'None', uncheckOthers: true },

      ]
    }
  },
  {
    label: 'SEXUAL HISTORY',
    educationalSlide: `Please complete the following set of questions.`,
    field: 'gn_intake_info2',
    type: 'info',
    answer: {}
  },
  //SEXUAL HISTORY
  {
    field: 'gn_intake_4',
    label: 'Are you currently sexually active?',
    subLabel: '(Select at least one, or all that apply)',
    // tooltip: [
    //   {
    //     title: 'Why are we asking this?',
    //     info: 'Knowing your goals means we can make a formula with ingredients geared to tackle those issues.',
    //     lineBreak: true
    //   }
    // ],
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Men', key: 'gn_intake_4_men' },
        { value: 'Women', key: 'gn_intake_4_women' },
        { value: 'Both', key: 'gn_intake_4_both', uncheckOthers: true },
        { value: 'None', key: 'gn_intake_4_none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'gn_intake_5',
    label: 'How many times do you have intercourse per week?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_5A'
    }
  },
  {
    field: 'gn_intake_6',
    label: 'Do you use lubricants?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'gn_intake_6_yes',
          value: 'Yes'
        },
        {
          key: 'gn_intake_6_no',
          value: 'No'
        }
      ]
    }
  },
  {
    field: 'gn_intake_7',
    label: 'Do you have pain with intercourse?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'gn_intake_7_yes',
          value: 'Yes'
        },
        {
          key: 'gn_intake_7_no',
          value: 'No'
        }
      ]
    }
  },
  {
    field: 'gn_intake_8',
    label: 'Do you struggle with any of the following?',
    subLabel: 'check all that apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'gn_intake_8_A',
          value: 'Sexual desire (libido)'
        },
        {
          key: 'gn_intake_8_B',
          value: 'Sexual arousal'
        },
        {
          key: 'gn_intake_8_C',
          value: 'Orgasm'
        },
        {
          key: 'gn_intake_8_D',
          value: 'Other',
          answer: {
            label: 'Please explain? ',
            type: 'text',
            name: 'gn_intake_8_Ddesc',
            required: false
          }
        }
      ]
    }
  },
  {
    field: 'gn_intake_11',
    label: 'Have you had any of the following infections?',
    subLabel: 'check all that apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'gn_intake_11_A',
          value: 'Chlamydia'
        },
        {
          key: 'gn_intake_11_B',
          value: 'Syphilis'
        },
        {
          key: 'gn_intake_11_C',
          value: 'HIV / AIDS'
        },
        {
          key: 'gn_intake_11_D',
          value: 'Gonorrhea'
        },
        {
          key: 'gn_intake_11_E',
          value: 'HPV / Genital Warts'
        },
        {
          key: 'gn_intake_11_F',
          value: 'Hepatitis'
        },
        { key: 'isNone', value: 'None', uncheckOthers: true }
      ]
    }
  },
  // PREGNANCY HISTORY
  {
    label: 'PREGNANCY HISTORY',
    educationalSlide: `Please complete your pregnancy history in this and previous relationships.`,
    field: 'gn_intake_12',
    type: 'info',
    answer: {}
  },
  {
    field: 'gn_intake_13',
    label: 'Number of total pregnancies?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_13_A'
    }
  },
  {
    field: 'gn_intake_14',
    label: 'Number of total miscarriages?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_14_A'
    }
  },
  {
    field: 'gn_intake_15',
    label: 'Number of total tubal / ectopic pregnancies?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_15_A'
    }
  },
  {
    field: 'gn_intake_16',
    label: 'Number of total abortions?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_16_A'
    }
  },
  {
    field: 'gn_intake_17',
    label: 'Number of full term Deliveries?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_17_A'
    }
  },
  {
    field: 'gn_intake_18',
    label: 'Number of preterm deliveries?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_18_A'
    }
  },
  {
    field: 'gn_intake_19',
    label: 'Date of Delivery / End of Pregnancy?',
    type: 'info',
    answer: {
      type: 'date',
      required: true,
      name: 'gn_intake_19_A'
    }
  },
  {
    field: 'gn_intake_20',
    label: 'Outcome / Complications?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'gn_intake_20_A'
    }
  },
  {
    field: 'gn_intake_21',
    label: 'Months to Conceive?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'gn_intake_21_A'
    }
  },
  {
    field: 'gn_intake_23',
    label: 'Treatment used to conceive?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'gn_intake_23_A'
    }
  },
  {
    field: 'gn_intake_24',
    label: 'Current Partner',
    type: 'info',
    answer: {
      type: 'text',
      name: 'gn_intake_24_A'
    }
  },
  {
    field: 'gn_intake_25',
    label: 'Date of last miscarriage?',
    type: 'info',
    answer: {
      type: 'date',
      required: true,
      name: 'gn_intake_25_A'
    }
  },
  ///
  /// MENSTRUAL / GYNECOLOGIC HISTORY
  ///
  {
    field: 'gn_intake_26',
    label: 'MENSTRUAL / GYNECOLOGIC HISTORY',
    educationalSlide: `Please complete your pregnancy history in this and previous relationships.`,
    type: 'info',
    answer: {}
  },
  {
    field: 'gn_intake_27',
    label:
      'Number of days between the start of one menstrual period and the start of the next one',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_27_A'
    }
  },
  {
    field: 'gn_intake_28',
    label: 'NumbNumber of days of bleeding',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_28_A'
    }
  },
  {
    field: 'gn_intake_29',
    label: 'Age when you had your first period',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_29_A'
    }
  },
  {
    field: 'gn_intake_30',
    label: 'First day of your last 3 periods',
    subLabel: 'Put 0 if no period',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_30_A'
    }
  },
  {
    field: 'gn_intake_31',
    label: 'Have you been tracking ovulation??',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'gn_intake_31_A', value: 'Home ovulation (LH) kit' },
        { key: 'gn_intake_31_B', value: 'Basal body temperature' },
        { key: 'gn_intake_31_C', value: 'Phone app' },
        {
          key: 'gn_intake_31_D',
          value: 'Other',
          answer: {
            name: 'gn_intake_31_DD',
            type: 'text',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    field: 'gn_intake_32',
    label: 'Do you have bleeding in between periods?',
    type: 'polar_check',
    answer: {
      label: 'For how long?',
      name: 'gn_intake_32_A',
      type: 'text'
    }
  },
  {
    field: 'gn_intake_33',
    label: 'Do you need medication to bring on a period?',
    type: 'polar_check',
    answer: {
      label: 'For how long?',
      name: 'gn_intake_33_A',
      type: 'text'
    }
  },
  {
    field: 'gn_intake_34',
    label: 'On scale from 1 - 5, how heavy are your periods (5 = Heaviest)?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_34_A'
    }
  },
  {
    field: 'gn_intake_35',
    label: 'On scale from 1 - 5, how painful are your periods (5 = Heaviest)?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'gn_intake_35_A'
    }
  },
  {
    field: 'gn_intake_36',
    label: 'Do you notice excessive facial / body hair?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'gn_intake_36_yes',
          value: 'Yes'
        },
        {
          key: 'gn_intake_36_no',
          value: 'No'
        }
      ]
    }
  },
  {
    field: 'gn_intake_37',
    label: 'Past contraception use?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'gn_intake_37_A',
          value: 'Birth control pill / patch / ring',
          answer: {
            name: 'gn_intake_37_AA',
            type: 'text',
            placeholder: 'When?'
          }
        },
        {
          key: 'gn_intake_37_B',
          value: 'IUD',
          answer: {
            name: 'gn_intake_37_BB',
            type: 'text',
            placeholder: 'When?'
          }
        },
        {
          key: 'gn_intake_37_C',
          value: 'Condoms',
          answer: {
            name: 'gn_intake_37_CC',
            type: 'text',
            placeholder: 'When?'
          }
        },
        {
          key: 'gn_intake_37_D',
          value: 'Other',
          answer: {
            name: 'gn_intake_37_DD',
            type: 'text',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'gn_intake_37_E',
          value: 'None',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'gn_intake_38',
    label: 'Have you ever had a pelvic exam or pap test?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'gn_intake_38_yes',
          value: 'Yes',
          answer: {
            name: 'gn_intake_38_yes_desc',
            type: 'text',
            placeholder: 'Date of last Pap Test:'
          }
        },
        {
          key: 'gn_intake_38_no',
          value: 'No'
        }
      ]
    }
  },
  {
    field: 'gn_intake_39',
    label: 'Have you ever had an abnormal pap test?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'gn_intake_39_yes',
          value: 'Yes'
        },
        {
          key: 'gn_intake_39_no',
          value: 'No'
        }
      ]
    }
  },
  {
    field: 'gn_intake_40',
    label:
      'Have you ever had any of the following because of an abnormal pap tests?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'gn_intake_40_A',
          value: 'Colposcopy'
        },
        {
          key: 'gn_intake_40_B',
          value: 'Cryosurgery (freezing)'
        },
        {
          key: 'gn_intake_40_C',
          value: 'Laser treatment'
        },
        {
          key: 'gn_intake_40_D',
          value: 'Conization (cone biopsy)'
        },
        {
          key: 'gn_intake_40_E',
          value: 'LEEP'
        },
        {
          key: 'gn_intake_40_F',
          value: 'None',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'gn_intake_41',
    label:
      'Have you had negative experiences in the past related to pelvic exams or pap tests, including avoiding them?',
    type: 'polar_check',
    answer: {
      label: 'Please explain?',
      name: 'gn_intake_41_A',
      type: 'text'
    }
  },
  {
    label: 'Please upload your most recent blood test results.',
    field: 'gn_blood_result',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'blood-test',
        buttonLabel: 'Upload Results'
      }
    ]
  }
];

export default questionsModels;
